import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../../hooks/useAppContext';


export const SetPageTitle = (props: { title?: string}) => {
  const [t] = useTranslation();
  const hostName = document.location.host;
  const {name:merchantName} = useAppContext();
  const pageTitle = t('clover_app_store.page_title',{title:props.title,hostName:hostName})
  const defaultPageTitle = merchantName? t('clover_app_store.default_page_title',{merchantName:merchantName,hostName:hostName}): t('clover_app_store.public_page_title');

  if(props.title){
    document.title = pageTitle
  }
  else{
    document.title = defaultPageTitle
  }
      return (
        <Helmet><title>{document.title}</title></Helmet>
      )
};
